<template>
  <main>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12 bd-callout bg-white">
          <!-- <div class="h5 mb-0 font-weight-bold text-primary">車位設定</div>
            <hr /> -->
          <div class="row">
            <div class="col-12">
              <table :class="tableStyle">
                <thead class="table-dark text-center">
                  <tr>
                    <th scope="col" width="10%">#</th>
                    <th scope="col" width="20%">使用者角色</th>
                    <!-- <th scope="col" width="35%">權限</th> -->
                    <th scope="col" width="35%">修改</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in roles" :key="key">
                    <td :class="tableCenterStyle">{{ key + 1 }}</td>
                    <td :class="tableCenterStyle">{{ item.text }}</td>
                    <!-- <td :class="tableCenterStyle">{{ item.id }}</td> -->
                    <td :class="tableCenterStyle">
                      <button class="btn btn-primary bg-indigo" @click="editPermission(item)">
                        編輯
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <dialog-modal ref="permissionEditor" :showUpdateButton="true" customUpdateButton="修改" :modalSize="''" :isImage="false"
      :isMarginAuto="false" @update-button-click="updatePermission">
      <div class="form-check" v-for="(sc, index) in scenicAreaList" :key="index">

        <label class="form-check-label" :for="sc.name + index">
          <input class="form-check-input" type="checkbox" :value="sc" :id="sc.name + index" v-model="checkboxArray[index]">
          {{ sc.name }}
        </label>
      </div>
    </dialog-modal>

    <!-- Modal -->
  </main>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import { users } from "resource";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import DialogModal from '../../components/DialogModal.vue'


export default {
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectScenicArea: null,

      roles: [],
      selectRole: null,
      checkboxArray: []
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapState("scenicArea", { myScenicAreaIdList: "myRoleToScenicAreaId" }),
    ...mapState("roleToScenicArea", { allRoleScenicArea: "allRoleScenicArea" }),
  },
  watch: {
    selectRole() {

    },

    allRoleScenicArea() {

    },
  },
  methods: {
    editPermission(item) {
      this.$refs.permissionEditor.openModal()
      this.selectRole = item
      const selectRoleScenicArea = this.allRoleScenicArea.find(roleSc => roleSc.roleId === this.selectRole.id)
      this.checkboxArray = this.scenicAreaList.map(sc => { return selectRoleScenicArea ? selectRoleScenicArea.scenicAreaIds.includes(sc.id) : false}) //新增的角色設為false

    },

    async updatePermission() {
      const permissionScemicArea = []
      this.checkboxArray.forEach((bool, index) => {
        if (bool) {
          permissionScemicArea.push(this.scenicAreaList[index]);
        }
      });

      const result = await this.$store.dispatch("roleToScenicArea/putAllRoleScenicAreaId", {roleId: this.selectRole.id, scenicAreaList: permissionScemicArea});

      if (result.success) {
        this.$refs.permissionEditor.closeModal()
        this.$store.dispatch('scenicArea/getMyRoleToScenicArea')
      } else {
        alert('編輯失敗')
      }
    },


  },

  async mounted() {
    users.roles().then(a => {
      this.roles = a.body
    })

    await this.$store.dispatch("roleToScenicArea/getAllRoleScenicAreaId");
  },
  components: { DialogModal },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>